import React from "react";

import { FloatingBar } from "../../floating-bar";

export function TopMenuRoot({ children }: { children: React.ReactNode }) {
	return (
		<FloatingBar.Provider>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "6px",
					alignItems: "flex-end",
				}}
			>
				{children}
			</div>
		</FloatingBar.Provider>
	);
}
